import React, { useState } from "react";
import { TableContainer, Table, Thead, Tr, Th, Tbody, Td, ButtonGroup, IconButton, Box, useToast, useDisclosure, Drawer, DrawerOverlay, DrawerContent, DrawerHeader, DrawerBody, LinkBox, Heading, LinkOverlay, Divider, Link } from "@chakra-ui/react";
import { CheckIcon, CloseIcon, EditIcon, DeleteIcon } from "@chakra-ui/icons";
import { useSelector } from "react-redux";
import { CONFIG } from "../utils/constants";
import axios from "axios";

interface SkiilsProps {
    skills: any[],
    onSkillDelete: () => void
}

export default function SkillsList(props: SkiilsProps) {
    const toast = useToast();
    const [employees, setEmployees] = useState<any[]>([]);
    const { isOpen, onOpen, onClose } = useDisclosure();

    const isAdmin = useSelector((state: any) => state.user.is_admin);
    const token = localStorage.getItem(CONFIG.TOKEN_KEY);
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    async function deleteSkill(skillUid: string) {
        try {
            await axios.delete(`${CONFIG.API_URL}/skills/delete/${skillUid}`);
            toast({
                position: 'top-right',
                title: 'Skill removed successfully',
                status: 'success',
                duration: 3000,
                isClosable: true
            });
            props.onSkillDelete();
        } catch (error) {
            toast({
                position: 'top-right',
                title: 'Unable to delete skill',
                status: 'error',
                duration: 3000,
                isClosable: true
            });
        }
    }

    function viewEmployeesList(emps: any[]) {
        if (emps.length) {
            setEmployees(emps);
        } else {
            setEmployees([]);
        }
        onOpen();
    }

    return (
        <>
            <Box
                boxShadow={'2xl'}
                my={4}
                padding={4}
                borderWidth="1px"
                borderRadius="lg"
                bg="white">
                <TableContainer>
                    <Table variant="striped">
                        <Thead>
                            <Tr>
                                <Th>Skill</Th>
                                <Th>Type</Th>
                                {isAdmin && <Th>Active</Th>}
                                <Th>Employees</Th>
                                {isAdmin && <Th>Action</Th>}
                            </Tr>
                        </Thead>
                        <Tbody>
                            {
                                props.skills.map((sk: any) => (
                                    <Tr key={sk._id}>
                                        <Td>{sk.name}</Td>
                                        <Td>{sk.type}</Td>
                                        {isAdmin && <Td>{sk.is_active ? <CheckIcon /> : <CloseIcon />}</Td>}
                                        <Td>
                                            <Link href="#" onClick={() => { viewEmployeesList(sk.employee_details) }}>
                                                {sk.employees.length}
                                            </Link>
                                        </Td>
                                        <Td>
                                            {
                                                isAdmin &&
                                                <ButtonGroup isAttached>
                                                    <IconButton size='xs' aria-label='Edit Skill' colorScheme='teal' icon={<EditIcon />} />
                                                    <IconButton size='xs' aria-label='Remove Skill' colorScheme='red' onClick={() => deleteSkill(sk.uid)} icon={<DeleteIcon />} />
                                                </ButtonGroup>
                                            }
                                        </Td>
                                    </Tr>
                                ))
                            }
                        </Tbody>
                    </Table>
                </TableContainer>
            </Box>
            <Drawer size="md" placement="right" onClose={onClose} isOpen={isOpen}>
                <DrawerOverlay />
                <DrawerContent>
                    <DrawerHeader borderBottomWidth='1px'>Employees</DrawerHeader>
                    <DrawerBody>
                        {
                            employees.map((emp: any) => (
                                <>
                                    <LinkBox>
                                        <Heading size="md" my={2}>
                                            <LinkOverlay href={`/employees/${emp.uid}`}>
                                                {emp.firstname} {emp.lastname}
                                            </LinkOverlay>
                                        </Heading>
                                    </LinkBox>
                                    <Divider mb={2} />
                                </>
                            ))
                        }
                    </DrawerBody>
                </DrawerContent>
            </Drawer>
        </>
    );
}